/* globals Union */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SuggestInput from './SuggestInput';
import Popover from './Popover';
import axios from '../lib/axios';

export default class RoomBookingAvailableBookingsCalendar extends Component {
  static propTypes = {
    date: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    location: PropTypes.string.isRequired,
    newBookingCallback: PropTypes.func.isRequired,
    newBookingBaseUrl: PropTypes.string.isRequired,
    useTimezone: PropTypes.string.isRequired,
    availableBookings: PropTypes.object.isRequired,
    halfHours: PropTypes.array.isRequired,
    hidden: PropTypes.bool.isRequired,
    sortedRooms: PropTypes.array.isRequired,
    userSuggestionUrl: PropTypes.string,
  }

  static defaultProps = {
    userSuggestionUrl: '',
  }

  constructor(props) {
    super(props);

    const showBookOnBehalfInput = (this.props.userSuggestionUrl !== '');
    this.state = { bookOnBehalfOfUserId: '', showBookOnBehalfInput };
  }

  componentDidMount() {
    Union.initialize();
    $(document).on('closed.fndtn.dropdown', () => {
      $('.BookingCalendar-halfHourSlot--isAvailable').remove();
    });
  }

  componentDidUpdate() {
    Union.initialize();
    $(document).on('closed.fndtn.dropdown', () => {
      $('.BookingCalendar-halfHourSlot--isAvailable').remove();
    });
  }

  //
  // AJAX
  //

  bookRoom = (booking, ref) => {
    const title = this[`title_${booking.roomId}_time_${moment(booking.startTime).tz(this.props.useTimezone).format('HHmm')}`].value;
    const user_id = [this.state.bookOnBehalfOfUserId];

    ref.current.hide();

    axios
      .request({
        method: 'post',
        url: `${this.props.newBookingBaseUrl}/${booking.roomId}/bookings`,
        data: {
          booking: {
            start_time: booking.startTime,
            end_time: booking.endTime,
            title,
            user_id
          },
          calendar: 'true'
        },
      })
      .then((response) => {
        this.props.newBookingCallback(response.data);
      })
  }

  //
  // UI HELPERS
  //

  illustrateBooking(booking) {
    this.setState({
      bookingRoom: booking.roomId,
      bookingStart: moment(booking.startTime),
      bookingEnd: moment(booking.endTime)
    });
  }

  renderHighlight(booking) {
    const shouldHighlight = (
      booking.roomId == this.state.bookingRoom &&
      moment(booking.startTime).isSameOrAfter(this.state.bookingStart) &&
      moment(booking.startTime).isBefore(this.state.bookingEnd)
    );

    const classes = ["BookingCalendar-halfHourSlot--isShown BookingCalendar-halfHourSlot--isAvailable"];

    if (moment(booking.startTime).isSame(this.state.bookingStart)) {
      classes.push("BookingCalendar-halfHourSlot--isAvailable-start");
    }
    if (moment(booking.startTime).add(30, 'minutes').isSame(this.state.bookingEnd)) {
      classes.push("BookingCalendar-halfHourSlot--isAvailable-end");
    }

    if (shouldHighlight) {
      return <div className={classes.join(" ")} />;
    } else {
      return '';
    }
  }

  formattedBookingIncrement(booking) {
    const startTime = this.formattedBookingTimeInTimezone(booking.startTime, 'h:mm A');
    const endTime = this.formattedBookingTimeInTimezone(booking.endTime, 'h:mm A z');
    return `${startTime} - ${endTime}`;
  }

  formattedBookingTimeInTimezone(time, format) {
    return moment(time).tz(this.props.useTimezone).format(format);
  }

  //
  // HELPERS
  //

  getHoursGrid() {
    const grid = {};
    const rooms = this.props.sortedRooms;

    rooms.forEach((roomId) => {
      grid[roomId] = {};
      this.props.halfHours.forEach((halfHour) => {
        grid[roomId][halfHour.format('HH:mm')] = { booked: true };
      });
      this.props.availableBookings[roomId].forEach((booking) => {
        const bookingStart = moment(booking.start_time);
        const bookingCurrent = bookingStart.clone();
        const bookingEnd = moment(booking.end_time);

        while (bookingCurrent < bookingEnd) {
          grid[roomId][this.formattedBookingTimeInTimezone(bookingCurrent.clone(), 'HH:mm')] = { available: true,
            booking: { room: booking.room, startTime: booking.start_time, endTime: booking.end_time, roomId: booking.room_id },
            start: booking.is_start_of_block && bookingCurrent.isSame(bookingStart),
            end: booking.is_end_of_block && bookingCurrent.clone().add(30, 'minutes').isSame(bookingEnd),
            start_time: bookingCurrent };
          bookingCurrent.add(30, 'minutes');
        }
      });
    });

    // Include filler columns if there are less than 7 rows
    if (rooms.length < 7) {
      for (let i = 0; i < 7 - rooms.length; i++) {
        const fillerId = `fillerColumn${i}`;
        grid[fillerId] = {};
        this.props.halfHours.forEach((halfHour) => {
          grid[fillerId][halfHour.format('HH:mm')] = { booked: true };
        });
      }
    }

    return grid;
  }

  getRooms() {
    return Object.keys(this.props.availableBookings);
  }

  bookOnBehalfOfUserAdded = (e) => {
    this.setState({ bookOnBehalfOfUserId: e.data.id });
  }

  bookOnBehalfOfUserRemoved = () => {
    this.setState({ bookOnBehalfOfUserId: '' });
  }

  renderBookRoomOnBehalfOfInput = () => {
    if (!this.state.showBookOnBehalfInput) { return null; }
    return (
      <div className="u-flex">
        <div className="u-w-full">
          <span className="u-hintText">On behalf of:</span>
          <SuggestInput
            dataOptions={[{ url: this.props.userSuggestionUrl, parameter: 'booking[user_id][]' }]}
            initialValue={[]}
            onRemoveResult={this.bookOnBehalfOfUserRemoved}
            onPickSuggestion={this.bookOnBehalfOfUserAdded}
            placeholder="Optional: Book for another user"
          />
        </div>
      </div>
    );
  }

  render() {
    const refs = {};
    const hoursGrid = this.getHoursGrid();
    return (
      <div hidden={this.props.hidden} id="available-rooms">
        {
          this.props.sortedRooms.map((roomId) => {
            const halfHours = [];
            refs[roomId] = {};
            this.props.halfHours.forEach((halfHour) => {
              const currentHalfHour = hoursGrid[roomId][halfHour.format('HH:mm')];
              refs[roomId][halfHour.format('HH:mm')] = React.createRef();

              if (currentHalfHour.booked) {
                halfHours.push(
                  <div
                    className="BookingCalendar-halfHourSlot"
                    id={`room_id_${roomId}_time_${moment(halfHour).format('HHmm')}`}
                    key={`${roomId}: ${halfHour.format('h:mm A')}`}
                  />);
              } else {
                const booking = currentHalfHour.booking;
                currentHalfHour.booking.popover = React.createRef();
                const triggerClasses = [
                  'BookingCalendar-halfHourSlot--isShown u-block'
                ];
                if (currentHalfHour.start) {
                  triggerClasses.push('BookingCalendar-halfHourSlot--shownStart');
                }
                if (currentHalfHour.end) {
                  triggerClasses.push('BookingCalendar-halfHourSlot--shownEnd');
                }

                halfHours.push(
                  <div
                    className="BookingCalendar-halfHourSlot u-w-full u-block u-relative"
                    id={`room_id_${roomId}_time_${moment(halfHour).format('HHmm')}`}
                    key={`${roomId}: ${halfHour.format('h:mm A')}`}
                  >
                    <Popover
                      ref={refs[roomId][halfHour.format('HH:mm')]}
                      icon={false}
                      triggerClass={triggerClasses.join(" ")}
                      popoverClass={`u-p-5 ${this.props.contentClassName}`}
                      onShow={this.illustrateBooking.bind(this, currentHalfHour.booking)}
                      onHide={() => this.setState({bookingRoom: null, bookingStart: null, bookingEnd: null})}
                    >
                      {this.renderBookRoomOnBehalfOfInput()}
                      <div>
                        <span className="u-hintText u-block">Room</span>
                        {booking.room}
                        <span className="u-hintText u-block">Time</span>
                        {this.formattedBookingIncrement(booking)}
                        <span className="u-hintText u-block">Title</span>
                        <div className="u-flex u-flex-row u-items-center u-justify-between">
                          <input
                            className="string optional"
                            type="text"
                            ref={(input) => { this[`title_${booking.roomId}_time_${moment(halfHour).format('HHmm')}`] = input; }}
                          />
                          <button
                            className="Button u-mb-4 u-ml-4"
                            type="submit"
                            role="button"
                            data-disableable="no-reset"
                            data-disable-message="Book"
                            onClick={() => this.bookRoom(currentHalfHour.booking, refs[roomId][halfHour.format('HH:mm')])}
                          >
                            Book
                          </button>
                        </div>
                      </div>
                    </Popover>
                    {this.renderHighlight(currentHalfHour.booking)}
                  </div>
                );
              }
            });

            return <div className="col" key={`${roomId} column`}>{halfHours}</div>;
          })
        }
      </div>
    );
  }
}
